export enum ThemeValidationErrorCode {
  INVALID_JSON = 'INVALID_JSON',
  PROP_NOT_ALLOWED = 'PROP_NOT_ALLOWED',
  INVALID_PROP_VALUE = 'INVALID_PROP_VALUE',
  NOT_SUPPORTED_PROP_TYPE = 'NOT_SUPPORTED_PROP_TYPE',
}
